<template>
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 512 512"
    style="enable-background: new 0 0 512 512"
    xml:space="preserve"
    :width="size"
    :height="size"
  >
    <g :fill="color" fill-rule="nonzero">
      <path d="M96,512h64V128h96L128,0L0,128h96V512z M512,384h-96V0h-64v384h-96l128,128L512,384z" />
    </g>
  </svg>
</template>
<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export class IconSort extends Vue {
  @Prop({ default: 26 }) public size!: number;
  @Prop({ default: "#ffffff" }) public color!: string;
}
export default IconSort;
</script>
